import {useContext, useEffect, useRef, useState} from "react";
import axios from "axios";
import {UserContext} from "./UserContext";
import {useNavigate} from "react-router-dom";
const AddProject = () =>{
    const [projectName,setProjectName] = useState("")
    const [projectShortDescription,setProjectShortDescription] = useState("")
    const [projectDescription,setProjectDescription] = useState("")
    const [projectTechStack,setProjectTechStack] = useState("")
    const [projectGithubLink,setProjectGithubLink] = useState("")
    const [projectLiveLink,setProjectLiveLink] = useState("")
    const [projectDisplayPhoto,setProjectDisplayPhoto] = useState()
    const [projectCategory,setProjectCategory] = useState("")
    const{access_token,initializing,backEndUrl} = useContext(UserContext)
    const [loading,setLoading] = useState("")
    const [error,setError] = useState("")
    const fileInputRef = useRef(null)
    const navigate = useNavigate()

    useEffect(()=>{
        if(initializing){
            setLoading("Please wait....")
        }else{
            setLoading("")
        }
    },[initializing])


    const ProjectSubmit =async (e) =>{
        e.preventDefault()
        setLoading("Submitting project details...")
        setError("")

        if (!access_token){
            setLoading("")
            setError("You dont have permission to access this page either try to login to the first")
            navigate("/signin")
            return
        }

        try{
            const newProject = new FormData()
            newProject.append("projectName",projectName)
            newProject.append("projectShortDescription",projectShortDescription)
            newProject.append("projectDescription",projectDescription)
            newProject.append("projectTechStack",projectTechStack)
            newProject.append("projectGithubLink",projectGithubLink)
            newProject.append("projectLiveLink",projectLiveLink)
            newProject.append("projectCategory",projectCategory)
            newProject.append("projectDisplayPhoto",projectDisplayPhoto)

            const response = await axios.post(`${backEndUrl}/add_project`,newProject,{headers:{Authorization:`Bearer ${access_token}`}})
            setLoading(response.data.message)
            setProjectName("")
            setProjectShortDescription("")
            setProjectDescription("")
            setProjectTechStack("")
            setProjectGithubLink("")
            setProjectLiveLink("")
            setProjectCategory("")
            setProjectDisplayPhoto(null)
            if(fileInputRef.current){
                fileInputRef.current.value = ""
            }
        } catch (error){
            setLoading("")
            setError(error.message)
        }

    }

    return (
        <section className="section">
            <div className="section-container form-layout">
                <div className="form-card">
                    <div className="section-header">
                        <p className="eyebrow">Admin only</p>
                        <h2>Add a new project</h2>
                        <p className="body-text">Share the essentials for a new case study. You can always update the backend later with richer content.</p>
                    </div>
                    {error && <div className="status-banner danger">{error}</div>}
                    {loading && <div className="status-banner info">{loading}</div>}
                    <form onSubmit={ProjectSubmit} className="grid-two">
                        <label className="form-field">
                            <span>Project name</span>
                            <input type="text" placeholder="Portfolio revamp" value={projectName}  onChange={e=>setProjectName(e.target.value)} required />
                        </label>

                        <label className="form-field">
                            <span>Short description</span>
                            <input type="text" placeholder="One-liner overview" value={projectShortDescription} onChange={e=>setProjectShortDescription(e.target.value)} required />
                        </label>

                        <label className="form-field full-width">
                            <span>Full description</span>
                            <textarea placeholder="Explain the goal, users, challenges and solution."
                                      value={projectDescription}
                                      onChange={e=>setProjectDescription(e.target.value)}
                                      rows={5}
                                      required />
                        </label>

                        <label className="form-field">
                            <span>Tech stack (JSON)</span>
                            <textarea
                                placeholder='{"techstack":["React","FastAPI","Postgres"]}'
                                value={projectTechStack}
                                onChange={e=>setProjectTechStack(e.target.value)}
                                rows={3}
                                required
                            />
                        </label>

                        <label className="form-field">
                            <span>GitHub link</span>
                            <input type="url" placeholder="https://github.com/..." value={projectGithubLink} onChange={e=>setProjectGithubLink(e.target.value)} required />
                        </label>

                        <label className="form-field">
                            <span>Live link</span>
                            <input type="url" placeholder="https://project.live" value={projectLiveLink} onChange={e=>setProjectLiveLink(e.target.value)} required />
                        </label>


                        <label className="form-field">
                            <span>Category</span>
                            <input type="text" placeholder="Web app" value={projectCategory} onChange={e=>setProjectCategory(e.target.value)} required />
                        </label>

                        <label className="form-field full-width">
                            <span>Display image</span>
                            <div className="file-input-wrapper">
                                <input 
                                    type="file" 
                                    ref={fileInputRef} 
                                    onChange={e=>setProjectDisplayPhoto(e.target.files[0])} 
                                    className="file-input"
                                    accept="image/*"
                                    required 
                                />
                                <button 
                                    type="button" 
                                    className="file-input-button"
                                    onClick={() => fileInputRef.current?.click()}
                                >
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                        <polyline points="17 8 12 3 7 8"></polyline>
                                        <line x1="12" y1="3" x2="12" y2="15"></line>
                                    </svg>
                                    <span className="file-input-text">
                                        {projectDisplayPhoto ? projectDisplayPhoto.name : "Choose image file"}
                                    </span>
                                </button>
                                {projectDisplayPhoto && (
                                    <button 
                                        type="button" 
                                        className="file-remove"
                                        onClick={() => {
                                            setProjectDisplayPhoto(null);
                                            if(fileInputRef.current) {
                                                fileInputRef.current.value = "";
                                            }
                                        }}
                                        aria-label="Remove file"
                                    >
                                        ×
                                    </button>
                                )}
                            </div>
                        </label>

                        <button type="submit" className="btn btn-accent full-width">Submit project</button>
                    </form>
                </div>
            </div>
        </section>
    )

}

export default AddProject